import { resto } from '@saucelabs/sl-util-axios';

export const getUserActivity = ({ format, level = 'user', since, username }) => (
  resto.get(`/rest/v1/users/${username}/activity`, { params: { format, level, since } })
);

export const getOrganizationActivity = ({ since } = {}) => (
  resto.get('/rest/v1/activity/organization', { params: { since } })
);

export const getTeamsActivity = ({ format, orgId, since, teamIds }) => (
  resto.get('/rest/v1/activity/teams', { params: { format, id: teamIds, org_id: orgId, since } })
);

export const getGroupsActivity = ({ format, groupIds, orgId, since }) => (
  resto.get('/rest/v1/activity/groups', { params: { format, id: groupIds, org_id: orgId, since } })
);
